module.exports = __webpack_public_path__ + "static/media/t02kz.483fe4b7.pdf";